import PrivateLayout from "@/components/layouts/private-layout";
import AddAdminPage from "@/pages/admins/add-admin";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/admins/new")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PrivateLayout>
      <AddAdminPage />
    </PrivateLayout>
  );
}
